export default __webpack_public_path__ + "static/media/partner-ecole-andre-piolat.84f6943c.png";